import { cn } from 'utils/helpers';

const EmailPanelSkeleton = ({ count = 1 }) =>
  Array.from({ length: count }).map(() => (
    <div
      className={cn(
        'rounded-[6px] animate-pulse h-[94px] w-full p-[22px] bg-fill-tertiary',
      )}
    >
      <div className="w-full h-[16px] bg-content bg-opacity-70 mb-[6px]" />
      <div className="w-1/4 h-[8px] bg-content bg-opacity-70" />
      <div className="w-full h-[16px] mt-[6px] bg-content bg-opacity-70" />
    </div>
  ));

export default EmailPanelSkeleton;
